import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/video/page.tsx");
